import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./pages/App";
import reportWebVitals from "./reportWebVitals";

import "./assets/css/App.css";
import "./assets/css/index.css";
import "react-day-picker/dist/style.css";

import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./config/reactQuery.config";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { SocketProvider } from "./context/SocketContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <SocketProvider>
          <TooltipProvider delayDuration={100}>
            <App />
            <Toaster richColors />
          </TooltipProvider>
        </SocketProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
